import { useMemo } from 'react';
import { ISpaceBreakDown } from 'spw-redux/modules/program-summary/types';
import { IProjectSpaceTypeCategory } from 'spw-redux/modules/projects/types';
import {
  CUSTOM_SUBCATEGORY,
  INDIVIDUAL_WORKSPACES_CATEGORY,
  PRIVATE_OFFICES_SUBCATEGORY,
  PRIVATE_OFFICE_SPACE_TYPES_MAP,
  WORKSTATIONS_SUBCATEGORY,
  WORKSTATION_SPACE_TYPES_MAP,
} from 'spw-constants';

export const useWorkspacesBreakdownBySubcategory = (
  spaceTypeCategory: IProjectSpaceTypeCategory,
  workspacesBreakdown: ISpaceBreakDown[]
) => {
  return useMemo(() => {
    const _wsBreakdownBySubcategory = {
      [WORKSTATIONS_SUBCATEGORY]: [],
      [PRIVATE_OFFICES_SUBCATEGORY]: [],
      [CUSTOM_SUBCATEGORY]: [],
    } as Record<string, ISpaceBreakDown[]>;

    if (
      spaceTypeCategory?.defaultSpaceTypeCategory?.category !==
      INDIVIDUAL_WORKSPACES_CATEGORY
    )
      return _wsBreakdownBySubcategory;

    workspacesBreakdown.forEach((wsBreakdown) => {
      if (PRIVATE_OFFICE_SPACE_TYPES_MAP?.[wsBreakdown.spaceType]) {
        _wsBreakdownBySubcategory[PRIVATE_OFFICES_SUBCATEGORY].push(
          wsBreakdown
        );
      } else if (WORKSTATION_SPACE_TYPES_MAP?.[wsBreakdown.spaceType]) {
        _wsBreakdownBySubcategory[WORKSTATIONS_SUBCATEGORY].push(wsBreakdown);
      } else {
        _wsBreakdownBySubcategory[CUSTOM_SUBCATEGORY].push(wsBreakdown);
      }
    });

    return _wsBreakdownBySubcategory;
  }, [
    spaceTypeCategory?.defaultSpaceTypeCategory?.category,
    workspacesBreakdown,
  ]);
};
